import { motion } from "framer-motion";
import { ChevronRight } from "lucide-react";
import { ASSETS, LINKS } from "@/constants/assets";

export const HeroSection = () => (
  <section className="relative min-h-screen flex items-center overflow-hidden z-[1]" data-testid="hero-section">
    <div className="absolute inset-0 z-0">
      <img src={ASSETS.heroAthlete} alt="Performance" className="w-full h-full object-cover opacity-40" />
      <div className="hero-overlay" />
    </div>

    <div className="logo-watermark-hero">
      <img src={ASSETS.logo} alt="" className="logo-glow-hero" />
    </div>

    <div className="relative z-[2] max-w-[1440px] mx-auto px-6 lg:px-12 pt-40 pb-24 w-full">
      <motion.div
        className="max-w-[720px] bg-gradient-to-r from-[rgba(3,11,24,0.95)] via-[rgba(3,11,24,0.85)] to-transparent p-8 rounded-lg"
        initial={{ opacity: 0, y: 24 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.8 }}
      >
        <motion.div
          className="inline-flex items-center gap-2 font-orbitron text-[11px] font-semibold tracking-[4px] uppercase text-[#60A5FA] px-5 py-2.5 border border-[rgba(59,130,246,0.4)] rounded-[3px] mb-8 bg-[rgba(3,11,24,0.9)] backdrop-blur-lg"
          initial={{ opacity: 0, y: 24 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ delay: 0.2 }}
          data-testid="hero-badge"
        >
          <span className="w-1.5 h-1.5 bg-[#3B82F6] rounded-full shadow-glow animate-pulse" />
          Medical Management Company
        </motion.div>

        <motion.h1
          className="font-orbitron text-5xl sm:text-6xl lg:text-8xl font-extrabold tracking-[4px] leading-[1.05] mb-8 text-white text-shadow"
          initial={{ opacity: 0, y: 24 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ delay: 0.4 }}
          data-testid="hero-title"
        >
          LIMITLESS<br />
          <span className="text-[#60A5FA]">CLINICAL</span><br />
          INTELLIGENCE
        </motion.h1>

        <motion.p
          className="font-outfit text-xl lg:text-2xl font-light leading-relaxed text-white/90 mb-12 max-w-[580px] text-shadow-sm"
          initial={{ opacity: 0, y: 24 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ delay: 0.6 }}
          data-testid="hero-subtitle"
        >
          AI-powered clinical operating system for modern practices. Transform your practice with intelligent intake, multi-domain analysis, and protocol-driven workflows.
        </motion.p>

        <motion.div
          className="flex gap-4 flex-wrap"
          initial={{ opacity: 0, y: 24 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ delay: 0.8 }}
        >
          <a href={LINKS.jotform} target="_blank" rel="noopener noreferrer" className="btn-primary" data-testid="hero-cta-primary">
            BOOK A STRATEGY CALL <ChevronRight className="w-4 h-4" />
          </a>
          <a href={LINKS.gamma} target="_blank" rel="noopener noreferrer" className="btn-secondary" data-testid="hero-cta-secondary">
            LEARN MORE
          </a>
        </motion.div>
      </motion.div>
    </div>

    <div className="scroll-indicator">
      <div className="scroll-indicator-inner" />
    </div>
  </section>
);
